import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import AppSidebar from "../../components/AppSidebar/AppSidebar";
import { Suspense, lazy } from "react";
import PageLoader from "../../components/PageLoader";

const SLOComponent = lazy(() => import("./slo-component"));

export default function SLO() {
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <AppSidebar />
        <Box style={{ width: "100%" }}>
          <Toolbar
            sx={{ borderBottom: "1px solid #cdcdcd", gap: "2%" }}
            variant="dense"
          >
            <Typography variant="h6">SLO</Typography>
          </Toolbar>
          <Suspense fallback={<PageLoader />}>
            <SLOComponent />
          </Suspense>
        </Box>
      </Box>
    </>
  );
}
